module.exports = {
  "1hr - 8hr": "1小时-8小时",
  "15min - 3hr": "15分钟-3小时",
  "40 TRY": "40 里拉",
  "50 TRY": "50 里拉",
  "50 USD": "50 美元",
  " Account": " 账号",
  " Minimum: 10 MYR": " 最低: 10 MYR",
  " Minimum: 50,000 IDR": " 最低: 50,000 IDR",
  " Minimum: 60,000 VND": " 最低: 60,000 VND",
  " Minimum: 100 THB": " 最低: 100 THB",
  "&nbsp; Back to Deposit Page": "&nbsp; 返回入金页面",
  "&nbsp; Payment Form": "&nbsp; 付款表格",
  "&nbsp; Send Money to <b>KOINTRA</b> Account": "&nbsp; 汇款至 <b>KOINTRA</b> 账户",
  "&nbsp; Send Money to <b>ARTSMRKTS</b> Account": "&nbsp; 汇款至 <b>ARTSMRKTS</b> 账户",
  "Accepted Currencies": "可接受货币",
  "Account Currency": "账户币种",
  "Account History": "账户历史记录",
  "Account ID": "账户 ID",
  "Account Name": "账户名称",
  "Account Number": "账号",
  "Account": "账户",
  "Accounts": "账户",
  "All of Time": "所有时间",
  "All proof of residences must be current, show the full document, clearly display the name and address, and show a provision of services such as money owed or paid.": "所有地址证明必须是最新的、完整的文件，并且必须显示名称、地址，以及提供诸如信贷或应付帐款之类的服务。",
  "All transactions made to date": "所有已完成交易",
  "Alternatif Bank": "备用银行",
  "Amount": "金额",
  "Approximate BTC Price :": "比特币参考价格 :",
  "Available Margin": "可用保证金",
  "BIC (Swift Code)": "BIC (SWIFT 码)",
  "BTC": "BTC",
  "Balance": "余额",
  "Bank Account": "银行账户",
  "Bank Address": "银行地址",
  "Bank Name": "银行名称",
  "Bank Statement": "银行对账单",
  "Please create a pattern.": "请创建模式",
  "You should write ‘Kointra and Date’ on a blank paper, take the selfie via your hand and register to the system.": "请您手持写明Kointra和日期的白纸拍照以注册到系统。",
  "Branch": "分行",
  "In this payment system, you can open an account quickly via our solution partner Kointra ‘Crypto Currency Exchange’.": "在这个支付系统中，您可以通过我们的合作伙伴‘Crypto Currency Exchange’快速开立账户。",
  "By its very nature, any investment in shares, stock options and similar and assimilated products is characterised by a certain degree of uncertainty and that, consequently, any investment of this nature involves risks for which the user is solely responsible and liable. Investments in securities may decline in value, which may result in the loss of your entire investment.": "就其性质而言，股票，股票期权和其他相似金融产品有一定程度的不确定性，因此任何这种性质的投资涉及的风险该用户是全权负责并承担。证券投资可能贬值，这可能导致你的整个投资的损失。",
  "Warning : All photos must be visible and updated.": "请注意： 所有照片必须是清晰和最新的。",
  "CUSTOMER PANEL": "客户后台",
  "Cancel Deposit": "取消入金",
  "Cancel": "取消",
  "Choose File": "选择文件",
  "Company Name": "公司名称",
  "Confirm Password": "确认密码",
  "Confirm Payment Form": "确认付款",
  "Confirm": "确认",
  "Copied !": "已复制！",
  "Country": "国家",
  "Create New Address": "建立新地址",
  "Create a Deposit Request": "创建存款请求",
  "Currency": "货币",
  "Customer Panel": "客户后台",
  "DEBUG": "调试",
  "Daily Technical View": "每日策略",
  "Daily": "每日",
  "Date": "日期",
  "Deposit History": "入金记录",
  "Deposit Now": "立即入金",
  "Deposit": "入金",
  "Deposits under this amount are not considered and will not be refunded.": "低于此金额的入金将不予退还。",
  "Document size must be less than 6 mb": "文件大小必须小于6 mb",
  "Don't have an account ?": "没有账户吗？",
  "Drop files here, or click to select files": "在这里拖放文件，或单击选择文件",
  "E-state place of residence": "现住地",
  "Email": "邮箱",
  "Enter password": "输入密码",
  "Enter user id": "输入账户名",
  "Equity": "净值",
  "Error !": "错误 !",
  "Error": "错误",
  "Files": "文件",
  "Welcome to Flash Pay,": "欢迎使用Flash Pay,",
  "Focus": "注意",
  "Free Margin": "免费保证金",
  "Free": "免费",
  "From Account": "从账户",
  "GB33CLRB04055100000240": "GB33CLRB04055100000240",
  "Given rates are indicative online prices. It may vary depend on BTC arrive time. Exchange rates are calculating after the BTC arrives.": "给出的汇率是指示性的在线价格，它取决于BTC的到达时间。汇率是在BTC到达之后计算的。",
  "Given rates are indicative online prices. It may vary depend on USDT arrive time. Exchange rates are calculating after the USDT arrives.": "给出的汇率是指示性的在线价格，它取决于USDT的到达时间。汇率是在USDT到达之后计算的。",
  "History Period Filter": "历史记录过滤器",
  "Home": "主页",
  "IBAN": "IBAN",
  "IDR": "IDR",
  "Identity Card Back": "身份证背面",
  "Identity Card Front": "身份证正面",
  "Identity Number": "身份证号码: Kimlik Numarası",
  "If Kointra and ARTSMRKTS’ email addresses are the same ; First deposit money in Kointra’s account then transfer it to ARTSMRKTS account ": "如果Kointra和 ARTSMRKTS 的电子邮件地址相同； 首先将钱存入Kointra帐户，然后将其转入ARTSMRKTS帐户 ",
  "If Kointra email address is different than ARTSMRKTS’ ; Please use your Kointra account details directly by funding account ": "如果Kointra电子邮件地址与 ARTSMRKTS 的电子邮件地址不同； 请直接通过Tra帐户使用您的Kointra帐户详细信息",
  "Important:": "重要：",
  "Instant": "即时",
  "Internal Transfer": "资金内转",
  "Invalid Amount: ": "无效金额: ",
  "Invalid Login Credentials": "无效的登录凭证",
  "Invalid amount.": "无效金额。: Geçersiz Miktar",
  "If you use your national identity card, then you must back side here. Only JPG files are supported.": "请在此上传身份证背面，仅支持jpg格式。",
  "If you use your national identity card, then you must upload the front side here. Only JPG files are supported.": "请在此上传身份证正面，仅支持jpg格式。",
  "Kointra Available Amount": "Kointra 可用金额",
  "By using Kointra as a bank account, you can fund your account in TL as fast as possible.": "将Kointra用作银行帐户，您可以使用TL快速存入资金。",
  "KointraPay minimum deposit amount is 100,00": "KointraPay最低存款为100,00",
  "Last transfer transactions": "最近一笔交易",
  "Latest Money Transfers": "最新汇款",
  "Loading Content": "正在加载内容",
  "Log In": "登录",
  "Login": "登录",
  "Logout": "退出登录",
  "Please add a bank account and an amount, then write a reference number to the note.": "请添加银行账户和金额，然后填写参考号码的说明。",
  "MYR": "MYR",
  "Manual": "手册",
  "Margin Level": "保证金等级",
  "Margin": "保证金",
  "Maximum: 250.000 TRY": "最大: 250.000 TRY",
  "Minimum: 0.003 BTC": "最小: 0.003 BTC",
  "Minimum: 50 MYR": "最小: 50 MYR",
  "Minimum: 50 TRY": "最小: 50 TRY",
  "Minimum: 200,000 IDR": "最小: 200,000 IDR",
  "Minimum: 300,000 VND": "最小: 300,000 VND",
  "Minimum: 500 RMB": "最小: 500 RMB",
  "Minimum: 500 THB": "最小: 500 THB",
  "Money Transfer": "汇款",
  "Monthly": "每月",
  "My Documents": "我的文档",
  "Name": "姓名",
  "Neteller Account": "Neteller账户",
  "No Record": "无记录",
  "No record!": "无记录！",
  "No transfer history": "无转账历史",
  "No": "无",
  "None of the services or products contained or referred to on this website are available to persons resident in any country, state or territory where distribution of such services or products would be contrary to local law or regulation.": " 没有包含或者提到任何一种违背了客户居住的国家，地区和领土当地法律法规的产品或者服务",
  "OR": "或者",
  "Open Live Account": "开立真实账户",
  "Open Positions": "创建订单",
  "Open an account with Kointra.com": "在Kointra.com开设账户",
  "Other": "其他",
  "PSP": "PSP",
  "Password can not be empty.": "密码不能为空。",
  "Password": "密码",
  "Pattern can not be empty.": "模式不能为空。",
  "Pattern": "模式",
  "Pending Orders": "待审核订单",
  "Pending": "待审核",
  "Please enter ID Number": "请输入身份证号码",
  "Please enter information about your transfer process.": "请输入您的转账信息",
  "Please select an account to transfer.": "请选择要转移的账户。",
  "Please select the account you want to process.": "请选择要处理的账户。",
  "Please upload your proof of residence": "请上传您的居住证明",
  "Processing Time / Fee": "处理时间/费用",
  "Profile": "个人信息",
  "Profit": "利润",
  "Proof of residences upload as a pdf or jpg ": "居住证明请使用PDF或jpg格式上传",
  "Read More": "更多内容",
  "Recent successful deposits": "最新入金",
  "Recent successful withdrawals": "最新出金",
  "Reference Number": "参考编号",
  "Register in to Kointra for Withdrawal!": "注册Kointra并提款！",
  "Register to your Kointra to continue": "注册Kointra并继续",
  "Register": "注册",
  "Research": "查看",
  "Residence": "地址",
  "Risk Warning: Forex, Commodities, Options and CFDs (OTC Trading) are leveraged products that carry a substantial risk of loss up to your invested capital and may not be suitable for everyone. Please ensure that you fully understand the risks involved and do not invest money you cannot afford to lose. Please refer to our full risk disclaimer.": "风险警告：外汇，商品，期权和差价合约（OTC交易）在您投入资金前可能会承受重大损失的风险，可能并不适合所有人。 请确保您完全了解所涉及的风险，并且不要投资无法承受的损失资金。 请参阅我们的完整风险免责声明。",
  "Select Account": "选择账户",
  "Select the account to be active.": "选择要激活的账户。",
  "Selfie": "自拍",
  "Send All Availble Margin": "发送所有可用保证金",
  "Send Transfer Request": "发送转移请求",
  "Sign in to Kointra account for Withdrawal!": "登录Kointra账户并出金！",
  "Sign in to your Kointra account to continue": "登录Kointra账户并继续",
  "Sort Code": "排序代码",
  "Status": "状态",
  "Success": "成功",
  "The <u><i>minimum</i></u> deposit amount is ": "最低存款金额为 <u><i>-</i></u>",
  "The displayed addresses are defined for you and balances are automatically added to your MetaTrader account.": "显示的地址是您自定义的，余额将会自动添加至您的MetaTrader账户中。",
  "These technical and research reports are provided for informative purposes only and in no way can they be considered as a recommendation by ARTSMRKTS to you to engage in any trade. Hence, ARTSMRKTS shall not be held responsible for any outcome of trading decisions, in regards with these reports or similar reports. You hereby acknowledge that using the information entailed in these reports is at your sole responsibility and you will have no claims with regards to these reports against ARTSMRKTS. If you do not agree to this, you are strongly advised not to use these reports.": "本文所含内容及观点仅为一般信息，并无任何意图被视为ARTSMRKTS英国买卖任何货币或差价合约的建议或请求。同时ARTSMRKTS英国也不对任何可能因参考本文内容及观点而产生的任何直接或间接的损失承担责任。您在此同意对于使用所含内容负全责，如果您不同意这一点，我们强烈建议您不要使用此报告。。",
  "This research is for our clients and prospective clients only. Other than disclosures relating to ARTSMRKTS, this research is based on current public information that we consider reliable, but we do not represent that it is accurate or complete, and it should not be relied on as such. The information, opinions, estimates and forecasts contained herein are as of the date hereof and are subject to change without prior notification. We seek to update our research as appropriate, but various regulations may prevent us from doing so. Other than certain industry reports published on a periodic basis, the large majority of reports are published at irregular intervals as appropriate in the analyst's judgment.": "我们只对我们客户提供本市场研究，除涉及ARTSMRKTS英国的披露，本研究报告是基于我们认为可靠的目前公开的信息，但我们不保证它的准确性和完整性，您不应该依赖于此报告。我们对文中所含内容及观点均可能在不被通知的情况下更改。我们会在合规范围内适时地更新我们的研究，除了定期出版的行业报告之外，绝大多数报告是在分析师认为合适时会不定期出版。",
  "To Account": "转至账户",
  "Total Deposit": "总存款t",
  "Total Withdrawal": "总提款",
  "Transfer Address": "转账地址",
  "Transfer Amount": "转账金额",
  "Transfer Detail": "转账信息",
  "Upload My Documents": "上传我的文件",
  "Upload Photo Id": "上传身份证明",
  "Upload Proof of Residence": "上传居住证明",
  "User Accounts": "U用户账户",
  "User Id": "用户ID",
  "User account management panel.": "客户管理面板。",
  "We do not provide financial advice to individuals nor assist nor advise in any way as to the personal financial situation of any individual. None of the information provided constitutes individualized investment advice or any legal, accounting, tax or other professional advice. We recommend that our website users not make any investment decision of any sort on the basis of the information and related products set out in our website, unless prior consultation is sought with a professional adviser that has full knowledge of their personal financial situation. Trading may not be suitable for all users of this website.": "在决定交易外汇之前，您需仔细考虑您的财务目标、经验水平和风险承受能力。文中所含任何意见、新闻、研究、分析、报价或其他信息等都仅作与本文所含主题相关的一般类信息，同时ARTSMRKTS英国不提供任何投资、法律或税务的建议。您需向合适的顾问征询所有关于投资、法律或税务方面的事宜。外汇和其他产品保证金交易存在高风险，不适合所有投资者。",
  "We need your Neteller Account ID and Secure ID information to make transactions..": "我们需要您的Neteller帐户ID和安全ID信息才能进行交易。",
  "Webinar": "网络研讨会",
  "Week Ahead": "提前一周",
  "Weekly": "每周",
  "Welcome to Customer Panel": "欢迎来到客户后台",
  "Withdrawal History": "出金历史",
  "Withdrawal": "出金",
  "Withdrawals are available": "可以出金",
  "Yes": "是",
  "You can create addresses using the Create new address button, but you must have used your previous addresses at least once.": "您可以使用“创建新地址”按钮创建地址，但是您必须至少使用一次以前的地址。",
  "You can not create reqeust below the minimum limit!": "您不能创建低于最低要求的订单！",
  "You have no open orders": "您没有未结订单",
  "You have no pending orders": "您没有待处理订单",
  "You have no successful deposit transactions.": "您没有成功的入金交易。",
  "You have no successful internal transfer.": "您没有成功的资金内转。",
  "You have no successful withdrawal transactions": "您没有成功的出金交易。",
  "You should drop any file!": "您应该删除所有文件！",
  "Your files are uploading, please wait...": "您的文件正在上传，请稍后……",
  "Your open transactions": "您的未结交易",
  "Your pending transactions": "您的待处理交易",
  "Password  must contain at least one lowercase letter, one uppercase letter and one special character.": "密码必须至少包含一个小写字母，一个大写字母和一个特殊字符。",
  "Please verify your password": "请验证您的密码",  
}